import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

interface FeatureCard {
  title: string;
  description: string;
}

interface Partner {
  name: string;
  logo?: string;
}

@Component({
  selector: 'app-auth-branding',
  standalone: true,
  templateUrl: './auth-branding.component.html',
  styleUrls: ['./auth-branding.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthBrandingComponent {
  public readonly features = signal<FeatureCard[]>([
    {
      title: 'Tool-Agnostic by Design',
      description: 'We run security across the stack you already have. No rip and replace.',
    },
    {
      title: 'Coordinated Response',
      description: 'Detection, containment, and documentation that run the same way across every client.',
    },
    {
      title: 'Defensible Outcomes',
      description: 'Audit-ready evidence and compliance mapping generated as the work gets done.',
    },
  ]);

  public readonly partners = signal<Partner[]>([
    { name: 'Zayo', logo: '/assets/logos/partners/zayo_logo.png' },
    { name: 'xtel', logo: '/assets/logos/partners/xtel_Logo.png' },
    { name: '5Point', logo: '/assets/logos/partners/fivepoint-logo.webp' },
    { name: 'Guardian', logo: '/assets/logos/partners/logoGB.png' },
    { name: 'DS24', logo: '/assets/logos/partners/DS24 Logo Horiz.png' },
  ]);
}
